import { DisplayValueContainer, ValueSize } from './DisplayValue.styles';

const DisplayValue = ({
  label,
  value,
  valueSize = 'medium',
  helper,
  valueDataIntercomTarget,
}: {
  label: React.ReactNode;
  value: React.ReactNode;
  helper?: React.ReactNode | null;
  valueSize?: ValueSize;
  valueDataIntercomTarget?: string;
}) => {
  return (
    <DisplayValueContainer $valueSize={valueSize}>
      <span className="display-label">{label}</span>
      <span
        className="display-value"
        data-intercom-target={valueDataIntercomTarget}
      >
        {value}
        {helper && <span className="display-value-helper">{helper}</span>}
      </span>
    </DisplayValueContainer>
  );
};

DisplayValue.defaultProps = {
  valueSize: 'medium',
  helper: null,
  valueDataIntercomTarget: undefined,
};

export default DisplayValue;
